<template>
	<div>
		<!--
		<div class="row">
			<b-tabs pills v-model="tabIndex">
				<b-tab v-for="(i,idx) in tabList" :key="idx" :title="i.name">
				</b-tab>
				<template #tabs-end>
					<b-nav-item class="filter" role="presentation" 
						@click.prevent="searchFilterButtonClick" href="#"><i class="fas fa-angle-down icon-down"></i><i class="fas fa-angle-up icon-up"></i></b-nav-item>
				</template>
			</b-tabs>
		</div>
		<div class="row">
			<div class="col-md-12 search form minimize"> 			
				<form class="search fuel formsearch" v-on:change="resumePilihan">
					<div class="button_attach_detach" style="float:right;">
						<b-button @click="floatingSearchForm" class="attach detach" variant="light" href="#"><i class="fas fa-angle-right"></i></b-button>
					</div>
					<div class="row">
						<div class="col-md-3 form-group">
							<ReportParamSelect title="Area" name="area" v-model="area" :options="options.area" />
						</div>
						<div class="col-md-3 form-group">
							<ReportParamSelect title="Status" name="status" v-model="status" :options="options.status" />
						</div>
					</div>
				</form>
			</div> 
		</div> 

		<div class="row">
			<div class="col-md-12 mx-auto">
				<div class="h-100 d-flex align-items-center justify-content-center">
					<ReportResultTable reportname="StoreList" :reportdata="reportdata" :reporturl="urlRequestParams"/>
					<Loader :loading="this.loading.table" :customclass="''" class="child"/>
				</div>
			</div>
		</div>
		-->

		<div class="row">
			<div class="col-md-12">
			
                <div>
                    <el-collapse>
                        <el-collapse-item>
                            <template slot="title">
                                <span style="color:#606266;font-size:14px;"><i class="header-icon el-icon-search"></i>&nbsp;&nbsp;&nbsp;Filter</span>
                            </template>
                            <el-form label-position="top" label-width="100px" class="ml-4">
                                <div class="row">
                                    <div class="col-md-6">
                                        <el-form-item label="Cafe:">
                                            <el-select v-model="branchid1" clearable filterable placeholder="Select Store" size="medium" style="width:100%;" name="branchid">
                                                <el-option v-for="item3 in store.list" :key="item3.BranchId" :label="item3.BPOSBranchName" :value="item3.BranchId">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </div>
                     
                                    <div class="col-md-6">
                                        <el-form-item label="Area">
                                            <el-radio-group v-model="area" size="small" name="area">
                                                <el-radio-button :label="item5.value" v-for="(item5, index5) in options.area" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
                                            </el-radio-group>
                                        </el-form-item>
                                    </div>

									<div class="col-md-6">
                                        <el-form-item label="Region">
                                            <el-radio-group v-model="region" size="small" name="region">
                                                <el-radio-button :label="item5.value" v-for="(item5, index5) in options.region" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
                                            </el-radio-group>
                                        </el-form-item>
                                    </div>

                                    <div class="col-md-6">
                                        <el-form-item label="Status">
                                            <el-radio-group v-model="status" size="small" name="status">
                                                <el-radio-button :label="item5.value" v-for="(item5, index5) in options.status" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
                                            </el-radio-group>
                                        </el-form-item>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-6">
                                        <el-button type="primary" size="medium" :loading="loading.table" @click="applyFilter" style="width:100%;">Apply Filter</el-button>
                                    </div>
                                </div>

                            </el-form>
                        </el-collapse-item>
                    </el-collapse>
                </div>

                <div class="row">
                    <div class="col-md-12 mx-auto">
                        <div class="h-100 d-flex align-items-center justify-content-center">
                            <ReportResultTable reportname="StationList" :reportdata="reportdata" :reporturl="urlRequestParams" select_url="/plant?station=" idcol="BranchId" :loading="loading.table"/>
                            
                        </div>
                    </div>
                </div>

				
			</div>
		</div>

	</div>
</template>

<script>

import Cafe from '@/components/page/Cafe.js'
//import ReportParamSelect from '@/views/pages/ReportParamSelect.vue'
import ReportResultTable from '@/views/pages/ReportResultTable2.vue'
import { AxiosWithJar, Config} from '@/utility.js'
//import Loader from '@/components/loader/Loader.vue'

export default
{
	extends: Cafe,
	components: { 
		//ReportParamSelect,
		ReportResultTable,
		//Loader,
	},

	data(){
		return {
			options: {
				area:[
					{ value: "", name: "ALL" }, 
					{ value: "1", name: "1" }, 
					{ value: "2", name: "2" }, 
					{ value: "3", name: "3" }, 
					{ value: "4", name: "4" }, 
					{ value: "5", name: "5" }, 
				],
				region:[
					{ value: "", name: "ALL" }, 
					{ value: "1", name: "1" }, 
					{ value: "2", name: "2" }, 
					{ value: "3", name: "3" }, 
					{ value: "4", name: "4" }, 
					{ value: "5", name: "5" }, 
					{ value: "6", name: "6" }, 
					{ value: "7", name: "7" }, 
				],
				status:[
					{ value: "", name: "ALL" }, 
					{ value: "1", name: "ACTIVE" }, 
					{ value: "0", name: "INACTIVE" }, 
				],
			},
			tabList:[
				{name:'Cafe'},
			],
			tabIndex: this.$route.query.tab ? this.$route.query.tab : 0, 
			area: this.$route.query.area ? this.$route.query.area : '',
			region: this.$route.query.region ? this.$route.query.region : '',
			status: this.$route.query.status ? this.$route.query.status : '',
			branchid1: this.$route.query.branchid ? this.$route.query.branchid : '',
			showmap:false,
			urlRequestParams: '',

			reportdata:[],
		}
	},

    mounted()
    {
        this.$emit('childrenRoute');
		this.loadCafeList()
		this.resumePilihan()
    },
    methods:{
		floatingSearchForm(){
			document.querySelector('.search.form').classList.toggle('floating')            
		},
		async loadCafeList() {
			let url = Config().apiURL + "/cafe/cafelist";
			await AxiosWithJar().get(url).then(result=>{
				if(result.data.data.length){
					this.store.list = result.data.data;
				}
			})
		},
		async resumePilihan(){
			this.urlRequestParams=Config().apiURL
			if (this.tabIndex == 0) this.urlRequestParams+='/cafe/cafelist?'

			this.urlRequestParams+='&area='+this.area
			this.urlRequestParams+='&region='+this.region
			this.urlRequestParams+='&status='+this.status
			this.urlRequestParams+='&branchid='+this.branchid1

			this.loading.table = true;
			AxiosWithJar().get(this.urlRequestParams)
				.then((response)=>{ 
					this.reportdata = response.data;
				})
				.catch(/*error => {
					//console.log(error)
				}*/)
				.finally(() => {
					this.loading.table = false;
				})
        },
		applyFilter() {
			this.resumePilihan()
        },
		searchFilterButtonClick(){
			document.querySelector('li.filter').classList.toggle('down')
			var select=document.querySelectorAll('.search.form')
			Array.from(select).map((e)=>{e.classList.toggle('minimize')})
		}
    }
}
</script>
<style>

.fade-enter-active, .fade-leave-active {
  opacity: 1;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

</style>